import { duration } from 'src/replicant/utils/duration';

// How many energy we give as gift
export const energyGiftAmount = 1;

// Maximal energy that user could have to be able claim reward
export const maxClaimEnergy = 99;

// How many bPoints we give as a gift
export const bpointGiftAmount = 100;

// How many gems we give as a gift
export const gemGiftAmount = 5;

// Max gem gifts a player can collect per JST day
export const maxDailyGiftClaims = 50;

// Max gems a player can collect from gifts per JST day
export const maxDailyGiftGems = maxDailyGiftClaims * gemGiftAmount;

// Cleanup old send messages from state
export const cleanupSendInterval = duration({ days: 30 });

// Cleanup old received messages from state
export const cleanupReceivedInterval = duration({ days: 7 });

// Duration needed for a friend to be considered inactive
export const FRIEND_INACTIVITY_THRESHOLD = duration({ days: 14 });

// Max senders/recipients resolved in a single sync gift action.
//
// Each recipient becomes an entry fetch plus a message write plus an index rebuild,
// fanned out under one unbounded Promise.all. Only the reads are throttled, and
// their cap is the same constant as the DynamoDB agent's socket pool, so the writes
// contend with the reads for the same sockets.
//
// 100 matches the chunk size replicant's own admin bulk postMessages tooling uses,
// and leaves room under the socket pool at the observed 348-372 recipients. See
// #11690.
export const giftBatchSize = 100;

// Max recipients per OA chatbot fan-out. Lower than giftBatchSize because every
// recipient becomes one LINE push, dispatched with no server-side concurrency
// limit and its own timeout and retries. Measured client-side failure rate for a
// single call is ~1.5% at 100 recipients and ~27% at 200, so this sits well inside
// the flat part of that curve. See #11690.
export const giftOaBatchSize = 50;
